<template>
  <li class="related-forum-item">
    <router-link 
      :to="{ name: 'ForumSection', params: { slug: forum.slug || forum.id } }" 
      class="forum-link typo-body-2"
    >
      {{ forum.name }}
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'RelatedForum',
  props: {
    forum: {
      type: Object,
      required: true,
      validator: (forum) => {
        // Either slug or id must be present for routing
        return forum.name && (forum.slug || forum.id);
      }
    }
  }
};
</script>

<style scoped>
.related-forum-item {
  margin-bottom: 10px;
  list-style-type: none;
}

.forum-link {
  color: var(--color-text-primary);
  text-decoration: none;
  display: block;
  padding: 8px 0;
  transition: color 0.3s ease;
}

.forum-link:hover {
  color: var(--color-highlight);
}
</style> 